import { gql, TypedDocumentNode } from "@apollo/client";

import { LogMessage, LogsResponse } from "types/generated";

type RunLogsView = Pick<
  LogsResponse,
  "exists" | "deleted" | "finished" | "expired" | "hasMore" | "nextToken"
> & {
  messages: Array<Pick<LogMessage, "message">>;
};

type RunLogsRun = {
  id: string;
  logs: RunLogsView | null;
};

export type StackLogsData = {
  stack: { id: string; run: RunLogsRun | null } | null;
};

export type ModuleLogsData = {
  module: { id: string; run: RunLogsRun | null } | null;
};

export const GET_STACK_LOGS: TypedDocumentNode<StackLogsData> = gql`
  query GetStackLogsNext(
    $stackId: ID!
    $runId: ID!
    $state: RunState!
    $token: String
    $stateVersion: Int
  ) {
    stack(id: $stackId) {
      id
      run(id: $runId) {
        id
        logs(state: $state, token: $token, stateVersion: $stateVersion) {
          exists
          deleted
          finished
          expired
          hasMore
          messages {
            message
          }
          nextToken
        }
      }
    }
  }
`;

export const GET_MODULE_LOGS: TypedDocumentNode<ModuleLogsData> = gql`
  query GetModuleLogsNext($moduleId: ID!, $runId: ID!, $state: RunState!, $token: String) {
    module(id: $moduleId) {
      id
      run(id: $runId) {
        id
        logs(state: $state, token: $token) {
          exists
          deleted
          finished
          hasMore
          expired
          messages {
            message
          }
          nextToken
        }
      }
    }
  }
`;
